<template>
  <SlideXLeftTransition>
    <div class='location-detail'
         v-show="isOpen" v-if="marker.location !== undefined">
      <div class="thumbnail">
        <div @click="hideDetails()" class="thumbnail-back"></div>
        <div class="thumbnail-text">
          <h1 class="thumbnail-title" v-html="marker.title"></h1>
          <h2 class="thumbnail-category" v-if="marker.category"
              v-html="marker.category"></h2>
        </div>
        <img class="thumbnail-image" :src="marker.thumbnail" alt="">
      </div>
      <div class="location-info">

        <!-- Opening hours, walking distance, partner label -->
        <div class="location-stats" v-if="walkingDistance.length || marker.waterPointType === 'Partner'">
          <span class="status" v-if="status"></span>
          <span class="walking-distance"
                v-if="walkingDistance.length"
                v-text="walkingDistance"></span>
          <span v-if="marker.waterPointType === 'Partner'"
                class="partner-label"></span>
        </div>

        <!-- Filter type, payment type, ...-->
        <div class="location-details">
          <div class="detail water-type" v-if="marker.waterPointType !== 'Punto Di Acquisto'">
            <!-- Acqua acquedotto potabile -->
            <span
              v-if="marker.waterType === 'Acqua pubblica'">
              <img class="detail-icon"
                   src="@/assets/icons/icon-publica.svg"
                   alt="">
            {{ $t('tap-water') }}
            </span>

            <!-- Acqua filtrata -->
            <span v-if="marker.waterType === 'Acqua filtrata'">
              <img class="detail-icon" src="@/assets/icons/icon-filtrata.svg"
                   alt="">
            {{ $t('filtered-water') }}
            </span>

            <!-- Acqua sorgiva -->
            <span v-if="marker.waterType === 'Acqua sorgiva'">
              <img class="detail-icon" src="@/assets/icons/icon-sorgiva.svg"
                   alt="">
            {{ $t('spring-water') }}
            </span>

            <!-- Acqua Dispenser -->
            <span v-if="marker.waterType === 'Acqua dispenser'">
              <img class="detail-icon" src="@/assets/icons/icon-dispenser.svg"
                   alt="">
            {{ $t('water-dispenser') }}
            </span>
          </div>

          <!-- Prices -->
          <div class="detail price" v-if="marker.waterPointType !== 'Punto Di Acquisto'">
            <!-- Gratuita -->
            <span v-if="marker.fee === 'Acqua gratuita'">
              <img class="detail-icon" src="@/assets/icons/icon-gratuita.svg"
                   alt="">
            {{ $t('free-water') }}
            </span>

            <!-- Pagamento -->
            <span v-if="marker.fee === 'Acqua a pagamento'">
              <img class="detail-icon"
                   src="@/assets/icons/icon-pagamento.svg"
                   alt="">
            {{ $t('paid-water') }}
            </span>

          </div>

          <!-- Water point types -->
          <div class="detail water-point-type">
            <!-- Partner -->
            <span
              v-if="marker.waterPointType === 'Partner'">
              <img class="detail-icon" src="@/assets/icons/icon-acquisto.svg"
                   alt="">
            {{ $t('partner') }}
            </span>
            <!-- Shop -->
            <span
              v-if="marker.waterPointType === 'Punto Di Acquisto'">
              <img class="detail-icon" src="@/assets/icons/icon-acquisto.svg"
                   alt="">
            {{ $t('refill-now-shop') }}
            </span>
          </div>
        </div>

        <hr>

        <!-- Address, opening hours, website -->
        <div class="location-contact">
          <h2>Info</h2>
          <div class="address contact-detail" v-if="marker.address">
            {{ marker.address }}
          </div>
          <div v-if="marker.hours" class="hours contact-detail" v-html="marker.hours">
          </div>
          <div v-if="marker.locationExtra" class="extra contact-detail" v-html="marker.locationExtra">
          </div>
          <a :href="'http://' +  marker.website.split('//').pop()"
             class="website gtm-website contact-detail" v-if="marker.website.length > 0" target="_blank">
            {{ marker.website }}
          </a>
          <a
            :href="$t('feedback-form-url') + '?title=' + marker.title + '&lat=' + marker.location.lat +' &lng=' + marker.location.lng "
            class="feedback contact-detail" target="_blank">
            {{ $t('feedback-form') }}
          </a>
        </div>
      </div>
      <!-- Google maps button -->
      <a class="map-button gtm-directions" :id="marker.title"
         :href="`https://www.google.com/maps/dir/?api=1&destination=${marker.location.lat},${marker.location.lng}`"
         target="_top">
        {{ $t('open-google-maps') }}
      </a>
      <span class="back" @click="hideDetails()">◄ Back to map</span>
      <a class="report" target="_top"
         :href="$t('error-form-url')">
        {{ $t('error-form') }}
      </a>
    </div>
  </SlideXLeftTransition>
</template>

<script>
// @ is an alias to /src
import { SlideXLeftTransition } from 'vue2-transitions'

export default {
  components: {
    SlideXLeftTransition
  },
  name: 'LocationDetail',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    status: {
      type: Boolean,
      default: false
    },
    marker: {
      type: Object
    },
    walkingDistance: {
      type: String,
      default: ''
    }
  },
  methods: {
    hideDetails () {
      this.$emit('hideDetails')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.location-detail {
  position: absolute;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 480px;
  background: white;
  color: $blue-dark;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-bottom: 10px;
}

.report {
  color: gray;
  font-size: 15px;
  text-align: center;
  padding: 5px;
  text-decoration: underline;
}

.location-contact {
  margin: 20px 40px 40px;
  font-size: 18px;
  line-height: 1.3;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .contact-detail {
    height: auto;
    margin-bottom: 25px;

    &::before{
      flex-shrink: 0;
      background-position: center center;
      background-repeat: no-repeat;
      height: 25px;
      width: 25px;
      margin-right: 20px;
      display: block;
    }
  }

  .extra {
    display: flex;
    line-height: 1.1;

    &::before {
      content: 'ⓘ';
      text-align: center;
      font-size: 25px;
    }
  }

  .hours {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &::before {
      content: ' ';
      background-image: url(~@/assets/icons/icon-time.svg);
    }
  }

  .address {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &::before {
      content: ' ';
      background-image: url(~@/assets/icons/icon-marker.svg);
    }
  }

  .website {
    display: flex;
    align-items: center;
    color: $blue-dark;
    text-decoration: underline;

    &::before {
      content: ' ';
      background-image: url(~@/assets/icons/icon-website.svg);
    }
  }

  .feedback {
    display: flex;
    color: #293171;
    text-decoration: underline;
    margin-bottom: 0;

    &::before {
      content: ' ';
      background-image: url(~@/assets/icons/add_location.svg);
    }
  }
}

.location-info {
  flex: auto;
}

.map-button {
  padding: 20px;
  background: $blue-dark;
  color: white;
  display: block;
  border-radius: 6px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  justify-self: flex-end;
  margin: 0 20px 20px;
}

.location-details {
  margin: 40px 20px 20px;
  display: flex;
  justify-content: space-between;

  .detail {
    width: 30%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }

  span {
    display: inline-block;
    border-radius: 50%;
    width: 95px;
    height: 95px;
    border: medium solid $blue-dark;
  }

  .detail-icon {
    margin-bottom: 30px;
  }

  img {
    width: auto;
    height: 70%;
    display: block;
    margin: 15% auto;
  }
}

.location-status {
  z-index: 50;
}

.location-stats {
  display: flex;
  height: 50px;
  align-items: center;
  padding: 2px 2px 2px 10px;
  border-radius: 30px;
  margin: -25px 20px 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 7px 25px;
  font-size: 13px;
  background: white;
  position: relative;
  line-height: 1;
  justify-content: space-between;
}

.walking-distance {
  color: $blue-light;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 15px;

  &:before {
    content: '';
    width: 30px;
    height: 30px;
    background: url(~@/assets/icons/walking-distance.svg);
    background-size: cover;
    display: inline-flex;
    margin-right: 10px;
  }
}

.partner-label {
  width: 45px;
  height: 45px;
  background: url(~@/assets/icons/partner-uff.svg);
  background-size: cover;
  align-self: flex-end;
}

.thumbnail {
  width: 100%;
  height: 200px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.1) 0 7px 25px;
}

.thumbnail-back {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 25px;
  height: 25px;
  background: url(~@/assets/icons/back.svg);
  background-size: cover;
  cursor: pointer;
}

.thumbnail-image {
  object-fit: cover;
  object-position: center center;
  width: 100%;
  height: 100%;
}

.thumbnail-text {
  position: absolute;
  bottom: 30px;
  left: 20px;
  right: 20px;
  color: white;
  line-height: 1.2;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}

.thumbnail-title {
  font-size: 29px;
  font-weight: bold;
  line-height: 1;
  margin: 0;
}

.thumbnail-category {
  margin-top: 5px;
  font-size: 18px;
}

.back {
  color: dimgrey;
  margin: 0 20px 10px;
  cursor: pointer;
}

</style>
